import http from '@/services/http';

//-------------------- GETS ----------------------

export async function getInvoicingCompanies(filter) {
  try {
    let res = await http.get('/InvoicingCompany');
    if (filter) {
      return res.data.data.filter(item => item[filter]);
    } else {
      return res.data.data;
    }
  } catch (e) {
    console.log(e);
  }
}

//-------------------- PUTS ----------------------

export async function updateInvoicingCompany(id, data) {
  try {
    const res = await http.put(`/InvoicingCompany/${id}`, data);
    return res;
  } catch (e) {
    console.log(e);
  }
}

//-------------------- POSTS ----------------------

export async function createNewInvoicingCompany(data) {
  try {
    const res = await http.post('InvoicingCompany', data);
    return res;
  } catch (e) {
    console.log(e);
  }
}
